import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../services/axiosInstance";

interface ResolvePathKey {
  id: number;
  key: string;
  display_name: string;
  page_config: Record<string, unknown> | null;
  key_type: string;
}

export interface ResolvePathSection {
  id: number;
  source_type: string;
  body: string | null;
  display_order: number;
}

export interface ResolvePathResult {
  key: ResolvePathKey;
  page_config: Record<string, unknown> | null;
  key_type: string | null;
  sections: ResolvePathSection[];
}

export function useResolvePath(pathname: string) {
  return useQuery<ResolvePathResult>({
    queryKey: ["cms-resolve-path", pathname],
    queryFn: async () => {
      const { data } = await apiClient.get("/v1/cms/resolve-path", {
        params: { path: pathname },
      });
      return data?.payload?.results;
    },
    staleTime: 60_000,
    retry: 1,
    enabled: !!pathname,
  });
}
